var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-header"},[_c('banner-header-desktop'),_vm._v(" "),_c('banner-header-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }